export default [
	{
		topicName: 'Array',
		position: 0,
		started: false,
		doneQuestions: 0,
		questions: [
			{
				"Topic": "Array",
				"Problem": "Reverse the array",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/write-a-program-to-reverse-an-array-or-string/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/reverse-the-array_1262298?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Array",
				"Problem": "Find the maximum and minimum element in an array",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/find-minimum-and-maximum-element-in-an-array4428/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/sum-of-max-and-min_1081476?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Array",
				"Problem": "Find the \"Kth\" max and min element of an array ",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/kth-smallest-element/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/kth-smallest-and-largest-element-of-array_1115488?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Array",
				"Problem": "Given an array which consists of only 0, 1 and 2. Sort the array without using any sorting algo",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/sort-an-array-of-0s-1s-and-2s/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/sort-0-1-2_631055?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Array",
				"Problem": "Move all the negative elements to one side of the array ",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/move-all-negative-elements-to-end1813/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/move-all-negative-numbers-to-beginning-and-positive-to-end_1112620?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Array",
				"Problem": "Find the Union and Intersection of the two sorted arrays.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/union-of-two-arrays/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/find-similarities-between-two-arrays_1229070?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Array",
				"Problem": "Write a program to cyclically rotate an array by one.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/cyclically-rotate-an-array-by-one/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/rotate-array_1230543?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Array",
				"Problem": "find Largest sum contiguous Subarray [V. IMP]",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/kadanes-algorithm/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/maximum-subarray-sum_630526?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Array",
				"Problem": "Minimise the maximum difference between heights [V.IMP]",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/minimize-the-heights3351/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimize-the-difference_3208652?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Array",
				"Problem": "Minimum no. of Jumps to reach end of an array",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/minimum-number-of-jumps/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimum-jumps_1062693?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Array",
				"Problem": "find duplicate in an array of N+1 Integers",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/find-the-duplicate-number/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/duplicate-in-array_893397?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Array",
				"Problem": "Merge 2 sorted arrays without using Extra space.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/merge-two-sorted-arrays-1587115620/1",
				"URL2": ""
			},
			{
				"Topic": "Array",
				"Problem": "Kadane's Algo [V.V.V.V.V IMP]",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/kadanes-algorithm/0",
				"URL2": ""
			},
			{
				"Topic": "Array",
				"Problem": "Merge Intervals",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/merge-intervals/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/merge-intervals_699917?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Array",
				"Problem": "Next Permutation",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/next-permutation/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/next-permutaion_893046?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Array",
				"Problem": "Count Inversion",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/inversion-of-array/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/count-inversions_615?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Array",
				"Problem": "Best time to buy and Sell stock",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/best-time-to-buy-and-sell-stock/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/stocks-are-profitable_893405?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Array",
				"Problem": "find all pairs on integer array whose sum is equal to given number",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/count-pairs-with-given-sum5022/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/pair-sum_1171154?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Array",
				"Problem": "find common elements In 3 sorted arrays",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/common-elements1132/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/common-elements-in-three-sorted-arrays_1113130?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Array",
				"Problem": "Rearrange the array in alternating positive and negative items with O(1) extra space",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/array-of-alternate-ve-and-ve-nos1401/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/rearrange-alternatively_873851?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Array",
				"Problem": "Find if there is any subarray with sum equal to 0",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/subarray-with-0-sum/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/subset-sum-equal-to-k_1550954?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Array",
				"Problem": "Find factorial of a large number",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/factorials-of-large-numbers/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/factorial-of-a-large-number_1115471?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Array",
				"Problem": "find maximum product subarray ",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/maximum-product-subarray3604/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/maximum-product-subarray_1115474?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Array",
				"Problem": "Find longest consecutive subsequence",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/longest-consecutive-subsequence/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/longest-consecutive-sequence_759408?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Array",
				"Problem": "Given an array of size n and a number k, find all elements that appear more than \" n/k \" times.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/majority-element-ii/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/elements-occur-more-than-n-k-times_1113146?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Array",
				"Problem": "Maximum profit by buying and selling a share atmost twice",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/best-time-to-buy-and-sell-stock-iii/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/buy-and-sell-stock_1071012?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Array",
				"Problem": "Find whether an array is a subset of another array",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/array-subset-of-another-array/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/check-subset_762948?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Array",
				"Problem": "Find the triplet that sum to a given value",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/triplet-sum-in-array/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/triplets-with-given-sum_893028?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Array",
				"Problem": "Trapping Rain water problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/trapping-rain-water/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/trapping-rainwater_630519?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Array",
				"Problem": "Chocolate Distribution problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/chocolate-distribution-problem/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/chocolate-problem_893280?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Array",
				"Problem": "Smallest Subarray with sum greater than a given value",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/minimum-size-subarray-sum/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/rahul-and-minimum-subarray_1551987?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Array",
				"Problem": "Three way partitioning of an array around a given value",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/three-way-partitioning/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/three-way-partition_1170519?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Array",
				"Problem": "Minimum swaps required bring elements less equal K together",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/minimum-swaps-required-to-bring-all-elements-less-than-or-equal-to-k-together/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimum-swaps-to-bring-all-elements-less-than-or-equal-to-k-together_1112657?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Array",
				"Problem": "Minimum no. of operations required to make an array palindrome",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/minimum-number-of-moves-to-make-palindrome/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/make-it-palindrome_3189160?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Array",
				"Problem": "Median of 2 sorted arrays of equal size",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/median-of-two-sorted-arrays/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/find-the-median-of-all-subarrays-of-a-particular-size_1229069?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Array",
				"Problem": "Median of 2 sorted arrays of different size",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/median-of-two-sorted-arrays/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/median-of-two-sorted-arrays_985294?topList=love-babbar-dsa-sheet-problems"
			}
		],
	},
	{
		topicName: 'Matrix',
		position: 1,
		started: false,
		doneQuestions: 0,
		questions: [
			{
				"Topic": "Matrix",
				"Problem": "Spiral traversal on a Matrix",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/spirally-traversing-a-matrix/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/spiral-matrix_840698?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Matrix",
				"Problem": "Search an element in a matriix",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/search-a-2d-matrix/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/search-in-a-row-wise-and-column-wise-sorted-matrix_839811?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Matrix",
				"Problem": "Find median in a row wise sorted matrix",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/median-in-a-row-wise-sorted-matrix1527/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/median-in-matrix_981178?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Matrix",
				"Problem": "Find row with maximum no. of 1's",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/row-with-max-1s0023/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/row-with-maximum-1-s_1112656?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Matrix",
				"Problem": "Print elements in sorted order using row-column wise sorted matrix",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/sorted-matrix/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/sorted-matrix_758931?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Matrix",
				"Problem": "Maximum size rectangle",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/max-rectangle/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/maximum-size-rectangle-sub-matrix-with-all-1-s_893017?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Matrix",
				"Problem": "Find a specific pair in matrix",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/find-a-specific-pair-in-matrix/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/find-a-specific-pair-in-the-matrix_1115467?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Matrix",
				"Problem": "Rotate matrix by 90 degrees",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/rotate-a-matrix-by-90-degree-in-clockwise-direction-without-using-any-extra-space/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/inplace-rotate-matrix-90-degree_839734?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Matrix",
				"Problem": "Kth smallest element in a row-column wise sorted matrix",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/kth-element-in-matrix/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/kth-minimum-floor_1115470?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Matrix",
				"Problem": "Common elements in all rows of a given matrix",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/common-elements-in-all-rows-of-a-given-matrix/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/common-elements-present-in-all-rows-of-a-matrix_1118111?topList=love-babbar-dsa-sheet-problems"
			}
		],
	},
	{
		topicName: 'String',
		position: 2,
		started: false,
		doneQuestions: 0,
		questions: [
			{
				"Topic": "String",
				"Problem": "Reverse a String",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/reverse-string/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/string-reverse_3210207?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "String",
				"Problem": "Check whether a String is Palindrome or not",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/palindrome-string0817/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/check-if-the-string-is-a-palindrome_1062633?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "String",
				"Problem": "Find Duplicate characters in a string",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/print-all-the-duplicates-in-the-input-string/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/duplicate-characters_3189116?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "String",
				"Problem": "Why strings are immutable in Java?",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.baeldung.com/java-string-immutable",
				"URL2": ""
			},
			{
				"Topic": "String",
				"Problem": "Write a Code to check whether one string is a rotation of another",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/a-program-to-check-if-strings-are-rotations-of-each-other/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/check-if-one-string-is-a-rotation-of-another-string_1115683?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "String",
				"Problem": "Write a Program to check whether a string is a valid shuffle of two strings or not",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.programiz.com/java-programming/examples/check-valid-shuffle-of-strings",
				"URL2": "https://www.codingninjas.com/codestudio/problems/shuffle-two-strings_1115692?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "String",
				"Problem": "Count and Say problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/count-and-say/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/write-as-you-speak_1090543?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "String",
				"Problem": "Write a program to find the longest Palindrome in a string.[ Longest palindromic Substring]",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/longest-palindrome-in-a-string/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/longest-palindromic-substring_758900?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "String",
				"Problem": "Find Longest Recurring Subsequence in String",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/longest-repeating-subsequence/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/longest-repeating-subsequence_1062697?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "String",
				"Problem": "Print all Subsequences of a string.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/print-subsequences-string/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/subsequences-of-string_985087?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "String",
				"Problem": "Print all the permutations of the given string",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/permutations-of-a-given-string/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/print-permutations-string_758958?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "String",
				"Problem": "Split the Binary string into two substring with equal 0’s and 1’s",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/split-the-binary-string-into-substrings-with-equal-number-of-0s-and-1s/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/sort-array-of-0s-and-1s_2656186?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "String",
				"Problem": "Word Wrap Problem [VERY IMP].",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/word-wrap/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/word-wrap_982931?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "String",
				"Problem": "EDIT Distance [Very Imp]",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/edit-distance3702/1",
				"URL2": ""
			},
			{
				"Topic": "String",
				"Problem": "Find next greater number with same set of digits. [Very Very IMP]",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/next-permutation/0",
				"URL2": ""
			},
			{
				"Topic": "String",
				"Problem": "Balanced Parenthesis problem.[Imp]",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/parenthesis-checker/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/valid-parenthesis_795104?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "String",
				"Problem": "Word break Problem[ Very Imp]",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/word-break/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/word-break-1_758963?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "String",
				"Problem": "Rabin Karp Algo",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/rabin-karp-algorithm-for-pattern-searching/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/stringmatch-rabincarp_1115738?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "String",
				"Problem": "KMP Algo",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/longest-prefix-suffix2527/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/find-pattern-in-string_1112621?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "String",
				"Problem": "Convert a Sentence into its equivalent mobile numeric keypad sequence.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/convert-sentence-equivalent-mobile-numeric-keypad-sequence/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/convert-sentence_1115490?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "String",
				"Problem": "Minimum number of bracket reversals needed to make an expression balanced.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/count-the-reversals/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimum-cost-to-make-string-valid_1115770?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "String",
				"Problem": "Count All Palindromic Subsequence in a given String.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/count-palindromic-subsequences/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/count-palindrome-words-in-a-sentence_975378?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "String",
				"Problem": "Count of number of given string in 2D character array",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/find-count-number-given-string-present-2d-character-array/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/count-strings_1118116?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "String",
				"Problem": "Search a Word in a 2D Grid of characters.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/find-the-string-in-grid/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/word-search_630520?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "String",
				"Problem": "Boyer Moore Algorithm for Pattern Searching.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/boyer-moore-algorithm-for-pattern-searching/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/boyer-moore-algorithm-for-pattern-searching_1115634?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "String",
				"Problem": "Converting Roman Numerals to Decimal",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/roman-number-to-integer/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/roman-number-to-integer_981308?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "String",
				"Problem": "Longest Common Prefix",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/longest-common-prefix/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/longest-common-prefix_2090383?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "String",
				"Problem": "Number of flips to make binary string alternate",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/min-number-of-flips/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/beautiful-string_1115625?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "String",
				"Problem": "Find the first repeated word in string.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/find-first-repeated-word-string/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/second-most-repeated-word_3210218?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "String",
				"Problem": "Minimum number of swaps for bracket balancing.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/minimum-swaps-for-bracket-balancing/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimum-number-of-swaps-for-bracket-balancing_1115682?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "String",
				"Problem": "Find the longest common subsequence between two strings.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/longest-common-subsequence/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/longest-common-subsequence_1063255?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "String",
				"Problem": "Program to generate all possible valid IP addresses from given  string.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/program-generate-possible-valid-ip-addresses-given-string/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/ip-address_992846?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "String",
				"Problem": "Write a program to find the smallest window that contains all characters of string itself.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/smallest-distant-window/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/shortest-substring-with-all-characters_704894?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "String",
				"Problem": "Rearrange characters in a string such that no two adjacent are same",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/rearrange-characters4649/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/rearrange-string_982765?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "String",
				"Problem": "Minimum characters to be added at front to make string palindrome",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/minimum-characters-added-front-make-string-palindrome/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimum-characters-for-palindrome_893000?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "String",
				"Problem": "Given a sequence of words, print all anagrams together",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/k-anagrams-1/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/group-anagrams-together_985354?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "String",
				"Problem": "Find the smallest window in a string containing all characters of another string",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/smallest-window-in-a-string-containing-all-the-characters-of-another-string/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/smallest-window-in-string-containing-all-the-characters-of-another-string_981175?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "String",
				"Problem": "Recursively remove all adjacent duplicates",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/consecutive-elements/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/remove-consecutive-duplicates_893195?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "String",
				"Problem": "String matching where one string contains wildcard characters",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/wildcard-string-matching/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/wildcard-pattern-matching_701650?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "String",
				"Problem": "Function to find Number of customers who could not get a computer",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/function-to-find-number-of-customers-who-could-not-get-a-computer/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/count-customers-who-did-not-get-a-computer_1115775?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "String",
				"Problem": "Transform One String to Another using Minimum Number of Given Operation",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/transform-one-string-to-another-using-minimum-number-of-given-operation/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimum-shift-operations_1115784?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "String",
				"Problem": "Check if two given strings are isomorphic to each other",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/isomorphic-strings/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/check-if-two-given-strings-are-isomorphic-to-each-other_1117636?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "String",
				"Problem": "Recursively print all sentences that can be formed from list of word lists",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/recursively-print-all-sentences-that-can-be-formed-from-list-of-word-lists/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/ninja-and-sentences_1123512?topList=love-babbar-dsa-sheet-problems"
			}
		],
	},
	{
		topicName: 'Search & Sort',
		position: 3,
		started: false,
		doneQuestions: 0,
		questions: [
			{
				"Topic": "Searching & Sorting",
				"Problem": "Find first and last positions of an element in a sorted array",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/first-and-last-occurrences-of-x/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/first-and-last-position-of-an-element-in-sorted-array_1082549?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "Find a Fixed Point (Value equal to index) in a given array",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/value-equal-to-index-value1330/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/value-equal-to-the-index-value_1115771?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "Search in a rotated sorted array",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/search-in-rotated-sorted-array/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/search-in-rotated-sorted-array_1082554?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "square root of an integer",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/count-squares3649/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/square-root-integral_893351?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "Maximum and minimum of an array using minimum number of comparisons",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/maximum-and-minimum-in-an-array/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/middle-of-three_1118283?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "Optimum location of point to minimize total distance",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/optimum-location-point-minimize-total-distance/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/optimum-location_1116097?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "Find the repeating and the missing",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/find-missing-and-repeating2512/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/find-the-repeating-and-missing-number_1062727?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "find majority element",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/majority-element/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/majority-element_842495?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "Searching in an array where adjacent differ by at most k",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/searching-in-an-array-where-adjacent-differ-by-at-most-k0456/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/find-student_3161883?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "find a pair with a given difference",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/find-pair-given-difference/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/pair-difference-k_1089634?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "find four elements that sum to a given value",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/find-all-four-sum-numbers/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/find-four-elements-that-sums-to-a-given-value_983605?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "maximum sum such that no 2 elements are adjacent",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/stickler-theif/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/is-it-a-tree_630511?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "Count triplet with sum smaller than a given value",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/count-triplets-with-sum-smaller-than-x5549/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/3-sum-smaller_3161884?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "merge 2 sorted arrays",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/merge-two-sorted-arrays/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/ninja-and-sorted-arrays_1214628?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "print all subarrays with 0 sum",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/zero-sum-subarrays/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/subarrays-with-zero-sum_3161876?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "Product array Puzzle",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/product-array-puzzle/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/product-of-array-except-self_630271?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "Sort array according to count of set bits",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/sort-by-set-bit-count/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/sort-an-array-according-to-the-count-of-set-bits_873142?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "minimum no. of swaps required to sort the array",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/minimum-swaps/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimum-swaps-to-sort-array_1806885?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "Bishu and Soldiers",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.hackerearth.com/problem/algorithm/bishu-and-soldiers-227/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/search-in-the-array_1116099?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "Rasta and Kheshtak",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.hackerearth.com/practice/algorithms/searching/binary-search/practice-problems/algorithm/rasta-and-kheshtak/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/ninja-and-his-sword_1164268?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "Kth smallest number again",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.hackerearth.com/practice/algorithms/searching/binary-search/practice-problems/algorithm/kth-smallest-number-again-2/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/kth-smallest-integer-in-ranges_1115609?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "Find pivot element in a sorted array",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "http://theoryofprogramming.com/2017/12/16/find-pivot-element-sorted-rotated-array/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/game-of-largest-element_1170064?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "K-th Element of Two Sorted Arrays",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/k-th-element-of-two-sorted-array/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/k-th-element-of-2-sorted-array_1164159?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "Aggressive cows",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.spoj.com/problems/AGGRCOW/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/chess-tournament_981299?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "Book Allocation Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/allocate-minimum-number-of-pages/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/ayush-gives-ninjatest_1097574?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "EKOSPOJ:",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.spoj.com/problems/EKO/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/kevin-and-his-fruits_1164267?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "Job Scheduling Algo",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/weighted-job-scheduling-log-n-time/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/weighted-job-scheduling_1094885?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "Missing Number in AP",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/arithmetic-number/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/missing-number-in-ap_975498?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "Smallest number with atleastn trailing zeroes infactorial",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/smallest-factorial-number5929/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/smallest-number-with-at-least-n-trailing-zeros-in-factorial_1115774?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "Painters Partition Problem:",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/allocate-minimum-number-of-pages/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/painter-s-partition-problem_1089557?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "ROTI-Prata SPOJ",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.spoj.com/problems/PRATA/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/cooking-ninjas_1164174?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "DoubleHelix SPOJ",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.spoj.com/problems/ANARC05B/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/maximize-the-sum_1118624?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "Subset Sums",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.spoj.com/problems/SUBSUMS/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/city-of-happy-people_1199336?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "Find the inversion count",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/inversion-of-array/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/equal-global-and-local-inversions_1463976?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "Implement Merge-sort in-place",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/in-place-merge-sort/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/merge-sort-in-place_1118623?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Searching & Sorting",
				"Problem": "Partitioning and Sorting Arrays with Many Repeated Entries",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.baeldung.com/java-sorting-arrays-with-repeated-entries",
				"URL2": "https://www.codingninjas.com/codestudio/problems/partitioning-and-sorting-arrays-with-many-repeated-entries_1170515?topList=love-babbar-dsa-sheet-problems"
			}
		],
	},
	{
		topicName: 'Linked List',
		position: 4,
		started: false,
		doneQuestions: 0,
		questions: [
			{
				"Topic": "LinkedList",
				"Problem": "Write a Program to reverse the Linked List. (Both Iterative and recursive)",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/reverse-a-linked-list/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/reverse-the-singly-linked-list_799897?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Reverse a Linked List in group of Given Size. [Very Imp]",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/reverse-a-linked-list-in-groups-of-given-size/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/reverse-a-ll_2271431?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Write a program to Detect loop in a linked list.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/detect-loop-in-linked-list/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/detect-the-cycle_1822910?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Write a program to Delete loop in a linked list.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/remove-loop-in-linked-list/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/detect-and-remove-cycle_920523?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Find the starting point of the loop. ",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/find-first-node-of-loop-in-a-linked-list/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/detect-the-first-node-of-the-loop_1112628?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Remove Duplicates in a sorted Linked List.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/remove-duplicate-element-from-sorted-linked-list/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/unique-sorted-list_2420283?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Remove Duplicates in a Un-sorted Linked List.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/remove-duplicates-from-an-unsorted-linked-list/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/remove-duplicates-from-unsorted-linked-list_1069331?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Write a Program to Move the last element to Front in a Linked List.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/move-last-element-to-front-of-a-given-linked-list/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/deleting-and-adding-the-last-node_1170051?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Add “1” to a number represented as a Linked List.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/add-1-to-a-number-represented-as-linked-list/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/add-one-to-linked-list_920456?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Add two numbers represented by linked lists.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/add-two-numbers-represented-by-linked-lists/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/add-two-numbers-as-linked-lists_1170520?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Intersection of two Sorted Linked List.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/intersection-of-two-sorted-linked-lists/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/intersection-of-linked-lists_3210610?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Intersection Point of two Linked Lists.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/intersection-point-in-y-shapped-linked-lists/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/intersection-of-linked-list_630457?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Merge Sort For Linked lists.[Very Important]",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/sort-a-linked-list/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/mergesort-linked-list_630514?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Quicksort for Linked Lists.[Very Important]",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/quick-sort-on-linked-list/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/quick-sort-on-linked-list_893099?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Find the middle Element of a linked list.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/middle-of-the-linked-list/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/middle-of-linked-list_973250?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Check if a linked list is a circular linked list.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/circular-linked-list/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/is-it-a-circular-linked-list_981265?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Split a Circular linked list into two halves.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/split-a-circular-linked-list-into-two-halves/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/split-a-circular-linked-list_1071003?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Write a Program to check whether the Singly Linked list is a palindrome or not.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/check-if-linked-list-is-pallindrome/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/palindrom-linked-list_799352?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Deletion from a Circular Linked List.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/deletion-and-reverse-in-linked-list/1/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/deletion-in-circular-linked-list_630409?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Reverse a Doubly Linked list.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/reverse-a-doubly-linked-list/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/reverse-a-doubly-linked-list_1116098?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Find pairs with a given sum in a DLL.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/find-pairs-given-sum-doubly-linked-list/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/find-pair-with-a-given-sum-in-a-doubly-linked-list_1164172?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Count triplets in a sorted DLL whose sum is equal to given value “X”.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/count-triplets-sorted-doubly-linked-list-whose-sum-equal-given-value-x/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/count-triplets_873377?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Sort a “k”sorted Doubly Linked list.[Very IMP]",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.codingninjas.com/codestudio/problems/sort-a-k-sorted-doubly-linked-list_1118118",
				"URL2": "https://www.codingninjas.com/codestudio/problems/sort-a-k-sorted-doubly-linked-list_1118118?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Rotate DoublyLinked list by N nodes.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/rotate-doubly-linked-list-n-nodes/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/rotate-dll_1115782?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Rotate a Doubly Linked list in group of Given Size.[Very IMP]",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/reverse-doubly-linked-list-groups-given-size/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/reverse-dll-nodes-in-groups_920399?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Can we reverse a linked list in less than O(n) ?",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/can-we-reverse-a-linked-list-in-less-than-on/",
				"URL2": ""
			},
			{
				"Topic": "LinkedList",
				"Problem": "Why Quicksort is preferred for. Arrays and Merge Sort for LinkedLists ?",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/why-quick-sort-preferred-for-arrays-and-merge-sort-for-linked-lists/",
				"URL2": ""
			},
			{
				"Topic": "LinkedList",
				"Problem": "Flatten a Linked List",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/flattening-a-linked-list/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/flatten-a-linked-list_1112655?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Sort a LL of 0's, 1's and 2's",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/given-a-linked-list-of-0s-1s-and-2s-sort-it/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/sort-linked-list-of-0s-1s-2s_1071937?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Clone a linked list with next and random pointer",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/clone-a-linked-list-with-next-and-random-pointer/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/clone-linked-list-with-random-pointer_873376?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Merge K sorted Linked list",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/merge-k-sorted-linked-lists/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/merge-k-sorted-lists_992772?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Multiply 2 no. represented by LL",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/multiply-two-linked-lists/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/multiply-linked-lists_983603?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Delete nodes which have a greater value on right side",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/delete-nodes-having-greater-value-on-right/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/delete-nodes-which-have-a-greater-value-on-right-side_1115785?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Segregate even and odd nodes in a Linked List",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/segregate-even-and-odd-nodes-in-a-linked-list/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/segregate-even-and-odd-nodes-in-a-linked-list_1116100?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Program for n’th node from the end of a Linked List",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/nth-node-from-end-of-linked-list/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/k-th-node-from-the-end-of-the-linked-list_1171164?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "LinkedList",
				"Problem": "Find the first non-repeating character from a stream of characters",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/first-non-repeating-character-in-a-stream/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/first-unique-character-in-a-string_893404?topList=love-babbar-dsa-sheet-problems"
			}
		],
	},
	{
		topicName: 'Binary Trees',
		position: 5,
		started: false,
		doneQuestions: 0,
		questions: [
			{
				"Topic": "Binary Trees",
				"Problem": "level order traversal",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/level-order-traversal/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/level-order-traversal_796002?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Reverse Level Order traversal",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/reverse-level-order-traversal/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/reverse-level-order-traversal_764339?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Height of a tree",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/height-of-binary-tree/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/calculate-the-height-of-binary-tree-using-inorder-and-level-order-traversal_841416?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Diameter of a tree",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/diameter-of-binary-tree/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/diameter-of-the-binary-tree_920552?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Mirror of a tree",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/invert-binary-tree/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/convert-binary-tree-to-mirror-tree_873140?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Inorder Traversal of a tree both using recursion and Iteration",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.techiedelight.com/inorder-tree-traversal-iterative-recursive/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/tree-traversal_981269?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Preorder Traversal of a tree both using recursion and Iteration",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.techiedelight.com/preorder-tree-traversal-iterative-recursive/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/preorder-traversal_2035934?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Postorder Traversal of a tree both using recursion and Iteration",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.techiedelight.com/postorder-tree-traversal-iterative-recursive/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/name_2035933?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Left View of a tree",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/left-view-of-binary-tree/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/left-view-of-a-binary-tree_920519?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Right View of Tree",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/right-view-of-binary-tree/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/right-view_764605?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Top View of a tree",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/top-view-of-binary-tree/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/top-view-of-the-tree_799401?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Bottom View of a tree",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/bottom-view-of-binary-tree/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/bottom-view-of-binary-tree_893110?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Zig-Zag traversal of a binary tree",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/zigzag-tree-traversal/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/zigzag-binary-tree-traversal_920532?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Check if a tree is balanced or not",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/check-for-balanced-tree/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/is-height-balanced-binary-tree_975497?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Diagonal Traversal of a Binary tree",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/diagonal-traversal-of-binary-tree/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/diagonal-traversal_893029?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Boundary traversal of a Binary tree",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/boundary-traversal-of-binary-tree/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/boundary-traversal_790725?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Construct Binary Tree from String with Bracket Representation",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/construct-binary-tree-from-string-with-bracket-representation/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/binary-tree-from-bracket_1118117?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Convert Binary tree into Doubly Linked List",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/binary-tree-to-dll/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/bst-to-sorted-dll_1263694?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Convert Binary tree into Sum tree",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/transform-to-sum-tree/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/convert-a-binary-tree-to-its-sum-tree_920395?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Construct Binary tree from Inorder and preorder traversal",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/construct-tree-1/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/construct-binary-tree-from-inorder-and-postorder-traversal_1266106?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Find minimum swaps required to convert a Binary tree into BST",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/minimum-swap-required-convert-binary-tree-binary-search-tree/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimum-swaps-to-convert-binary-tree-into-bst_1118109?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Check if Binary tree is Sum tree or not",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/sum-tree/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/check-if-binary-tree-is-sum-tree-or-not_1164404?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Check if all leaf nodes are at same level or not",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/leaf-at-same-level/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/level-leaf_3210614?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Check if a Binary Tree contains duplicate subtrees of size 2 or more [ IMP ]",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/duplicate-subtree-in-binary-tree/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/check-for-duplicate-subtree_1089641?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Check if 2 trees are mirror or not",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/check-mirror-in-n-ary-tree/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/check-for-mirror-trees_3125887?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Sum of Nodes on the Longest path from root to leaf node ",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/sum-of-the-longest-bloodline-of-a-tree/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/longest-path_3210613?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Check if given graph is tree or not.  [ IMP ]",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/check-given-graph-tree/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/is-graph-tree_1115787?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Find Largest subtree sum in a tree",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/find-largest-subtree-sum-tree/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/maximum-subtree-sum_1082330?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Maximum Sum of nodes in Binary tree such that no two are adjacent ",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/maximum-sum-nodes-binary-tree-no-two-adjacent/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/maximum-sum-of-nodes-in-a-binary-tree-such-that-no-two-nodes-are-adjacent_1118112?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Print all \"K\" Sum paths in a Binary tree",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/print-k-sum-paths-binary-tree/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/number-of-ways-for-the-sum-k_1164407?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Find LCA in a Binary tree",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/lowest-common-ancestor-in-a-binary-tree/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/least-common-ancestor_1092611?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Find distance between 2 nodes in a Binary tree",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/min-distance-between-two-given-nodes-of-a-binary-tree/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/distance-between-two-nodes-of-a-tree_800303?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Kth Ancestor of node in a Binary tree",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/kth-ancestor-node-binary-tree-set-2/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/kth-ancestor-of-a-node-in-binary-tree_842561?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Find all Duplicate subtrees in a Binary tree [ IMP ]",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/duplicate-subtrees/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/duplicate-subtrees_920530?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Trees",
				"Problem": "Tree Isomorphism Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/check-if-tree-is-isomorphic/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/isomorphic-trees_794946?topList=love-babbar-dsa-sheet-problems"
			}
		],
	},
	{
		topicName: 'BST',
		position: 6,
		started: false,
		doneQuestions: 0,
		questions: [
			{
				"Topic": "Binary Search Trees",
				"Problem": "Find a value in a BST",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/search-a-node-in-bst/1/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/find-a-value-in-bst_1170063?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Search Trees",
				"Problem": "Deletion of a node in a BST",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/delete-node-in-a-bst/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/delete-node-in-bst_920381?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Search Trees",
				"Problem": "Find min and max value in a BST",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/minimum-element-in-bst/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/guess-price_3211264?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Search Trees",
				"Problem": "Find inorder successor and inorder predecessor in a BST",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/predecessor-and-successor/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/_893049?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Search Trees",
				"Problem": "Check if a tree is a BST or not ",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/check-for-bst/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/validate-bst_799483?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Search Trees",
				"Problem": "Populate Inorder successor of all nodes",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/populate-inorder-successor-for-all-nodes/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/populate-inorder-successor-of-all-nodes-of-a-binary-tree_1118625?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Search Trees",
				"Problem": "Find LCA  of 2 nodes in a BST",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/lowest-common-ancestor-in-a-bst/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/lca-in-a-bst_981280?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Search Trees",
				"Problem": "Construct BST from preorder traversal",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/construct-binary-search-tree-from-preorder-traversal/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/bst-from-preorder_2689307?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Search Trees",
				"Problem": "Convert Binary tree into BST",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/binary-tree-to-bst/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/binary-tree-to-bst_893074?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Search Trees",
				"Problem": "Convert a normal BST into a Balanced BST",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/convert-normal-bst-balanced-bst/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/normal-bst-to-balanced-bst_920472?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Search Trees",
				"Problem": "Merge two BST [ V.V.V>IMP ]",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/merge-two-balanced-binary-search-trees/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/h_920474?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Search Trees",
				"Problem": "Find Kth largest element in a BST",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/kth-largest-element-in-bst/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/k-th-largest-number_920438?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Search Trees",
				"Problem": "Find Kth smallest element in a BST",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/find-k-th-smallest-element-in-bst/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/kth-smallest-node-in-bst_920441?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Search Trees",
				"Problem": "Count pairs from 2 BST whose sum is equal to given value \"X\"",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/brothers-from-different-root/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/count-couples_3208653?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Search Trees",
				"Problem": "Find the median of BST in O(n) time and O(1) space",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/find-median-bst-time-o1-space/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/median-of-a-bst_893184?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Search Trees",
				"Problem": "Count BST nodes that lie in a given range",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/count-bst-nodes-that-lie-in-a-given-range/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/bst-queries_1095658?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Search Trees",
				"Problem": "Replace every element with the least greater element on its right",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/replace-every-element-with-the-least-greater-element-on-its-right/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/least-greater-element_1164266?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Search Trees",
				"Problem": "Given \"n\" appointments, find the conflicting appointments",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/given-n-appointments-find-conflicting-appointments/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/find-conflicting-meetings_1170047?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Search Trees",
				"Problem": "Check preorder is valid or not",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/preorder-to-postorder/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/check-if-preorder-traversal-is-valid_1164410?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Search Trees",
				"Problem": "Check whether BST contains Dead end",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/check-whether-bst-contains-dead-end/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/check-for-dead-end-in-a-bst_1169457?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Search Trees",
				"Problem": "Largest BST in a Binary Tree [ V.V.V.V.V IMP ]",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/largest-bst/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/largest-bst-subtree_893103?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Binary Search Trees",
				"Problem": "Flatten BST to sorted list",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/flatten-bst-to-sorted-list-increasing-order/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/flatten-bst-to-a-sorted-list_1169459?topList=love-babbar-dsa-sheet-problems"
			}
		],
	},
	{
		topicName: 'Greedy',
		position: 7,
		started: false,
		doneQuestions: 0,
		questions: [
			{
				"Topic": "Greedy",
				"Problem": "Activity Selection Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/activity-selection-1587115620/1/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/maximum-activities_1062712?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Greedy",
				"Problem": "Job Sequencing Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/job-sequencing-problem/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/job-sequencing-problem_1169460?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Greedy",
				"Problem": "Huffman Coding",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/huffman-encoding/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/huffman-coding_1169467?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Greedy",
				"Problem": "Water Connection Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/water-connection-problem/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimum-weight-in-a-connected-component_1170508?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Greedy",
				"Problem": "Fractional Knapsack Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/fractional-knapsack/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/fractional-knapsack_975286?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Greedy",
				"Problem": "Greedy Algorithm to find Minimum number of Coins",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/coin-piles/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/greedy-algorithm-for-ninja-and-the-coins_3191489?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Greedy",
				"Problem": "Maximum trains for which stoppage can be provided",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/maximum-trains-stoppage-can-provided/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/maximum-trains-for-which-stoppage-can-be-provided_1169456?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Greedy",
				"Problem": "Minimum Platforms Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/minimum-platforms/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimum-number-of-platforms_799400?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Greedy",
				"Problem": "Buy Maximum Stocks if i stocks can be bought on i-th day",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/buy-maximum-stocks-stocks-can-bought-th-day/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/maximum-shares_3114365?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Greedy",
				"Problem": "Find the minimum and maximum amount to buy all N candies",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/shop-in-candy-store/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimum-and-maximum-cost-to-buy-n-candies_975298?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Greedy",
				"Problem": "Minimize Cash Flow among a given set of friends who have borrowed money from each other",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/minimize-cash-flow-among-given-set-friends-borrowed-money/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimize-cash-flow-among-a-given-set-of-friends-who-have-borrowed-money-from-each-other_1170048?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Greedy",
				"Problem": "Minimum Cost to cut a board into squares",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/minimum-cost-cut-board-squares/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/board-cutting_975500?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Greedy",
				"Problem": "Check if it is possible to survive on Island",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/survival/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/check-if-possible-to-survive_1170052?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Greedy",
				"Problem": "Find maximum meetings in one room",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/find-maximum-meetings-in-one-room/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/maximum-meetings_1062658?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Greedy",
				"Problem": "Maximum product subset of an array",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/maximum-product-subset-array/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/max-product-subset_1170054?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Greedy",
				"Problem": "Maximize array sum after K negations",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/maximize-sum-after-k-negations/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/max-sum-after-k-negations_1170050?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Greedy",
				"Problem": "Maximize the sum of arr[i]*i",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/maximize-arrii-of-an-array/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/maximum-sum_2824971?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Greedy",
				"Problem": "Maximum sum of absolute difference of an array",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/maximum-sum-absolute-difference-array/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/maximum-sum-of-absolute-difference_1164175?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Greedy",
				"Problem": "Maximize sum of consecutive differences in a circular array",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/swap-and-maximize/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/swap-and-maximise_1164405?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Greedy",
				"Problem": "Minimum sum of absolute difference of pairs of two arrays",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/minimum-sum-absolute-difference-pairs-two-arrays/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimum-difference_1164402?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Greedy",
				"Problem": "Program for Shortest Job First (or SJF) CPU Scheduling",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/program-for-shortest-job-first-or-sjf-cpu-scheduling-set-1-non-preemptive/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/sjf_1172165?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Greedy",
				"Problem": "Program for Least Recently Used (LRU) Page Replacement algorithm",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/page-faults-in-lru/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/page-faults_2826682?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Greedy",
				"Problem": "Smallest subset with sum greater than all other elements",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/smallest-subset-sum-greater-elements/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/find-the-smallest-subset-of-balls-whose-weight-is-greater-than-the-weight-of-remaining-balls_1170530?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Greedy",
				"Problem": "Chocolate Distribution Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/chocolate-distribution-problem/0",
				"URL2": ""
			},
			{
				"Topic": "Greedy",
				"Problem": "DEFKIN -Defense of a Kingdom",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.spoj.com/problems/DEFKIN/",
				"URL2": ""
			},
			{
				"Topic": "Greedy",
				"Problem": "DIEHARD -DIE HARD",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.spoj.com/problems/DIEHARD/",
				"URL2": ""
			},
			{
				"Topic": "Greedy",
				"Problem": "GERGOVIA -Wine trading in Gergovia",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.spoj.com/problems/GERGOVIA/",
				"URL2": ""
			},
			{
				"Topic": "Greedy",
				"Problem": "Picking Up Chicks",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.spoj.com/problems/GCJ101BB/",
				"URL2": ""
			},
			{
				"Topic": "Greedy",
				"Problem": "CHOCOLA –Chocolate",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.spoj.com/problems/CHOCOLA/",
				"URL2": ""
			},
			{
				"Topic": "Greedy",
				"Problem": "ARRANGE -Arranging Amplifiers",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.spoj.com/problems/ARRANGE/",
				"URL2": ""
			},
			{
				"Topic": "Greedy",
				"Problem": "K Centers Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/k-centers-problem-set-1-greedy-approximate-algorithm/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/k-centers_1280117?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Greedy",
				"Problem": "Minimum Cost of ropes",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/minimum-cost-of-ropes/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/connect-n-ropes-with-minimum-cost_630476?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Greedy",
				"Problem": "Find smallest number with given number of digits and sum of digits",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/smallest-number5829/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/smallest-number_1164401?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Greedy",
				"Problem": "Rearrange characters in a string such that no two adjacent are same",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/rearrange-characters4649/1",
				"URL2": ""
			},
			{
				"Topic": "Greedy",
				"Problem": "Find maximum sum possible equal sum of three stacks",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/find-maximum-sum-possible-equal-sum-three-stacks/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/maximum-equal-sum-stack_1164270?topList=love-babbar-dsa-sheet-problems"
			}
		],
	},
	{
		topicName: 'BackTracking',
		position: 8,
		started: false,
		doneQuestions: 0,
		questions: [
			{
				"Topic": "BackTracking",
				"Problem": "Rat in a maze Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/rat-in-a-maze-problem/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/rat-in-a-maze_1215030?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "BackTracking",
				"Problem": "Printing all solutions in N-Queen Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/printing-solutions-n-queen-problem/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/the-n-queens-puzzle_981286?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "BackTracking",
				"Problem": "Word Break Problem using Backtracking",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/word-break-part-2/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/word-break-ii_983635?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "BackTracking",
				"Problem": "Remove Invalid Parentheses",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/remove-invalid-parentheses/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/generate-all-valid-strings_1170524?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "BackTracking",
				"Problem": "Sudoku Solver",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/solve-the-sudoku/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/sudoku-solver_699919?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "BackTracking",
				"Problem": "m Coloring Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/m-coloring-problem/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/m-coloring-problem_981273?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "BackTracking",
				"Problem": "Print all palindromic partitions of a string",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/given-a-string-print-all-possible-palindromic-partition/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/palindrome-partitions_981290?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "BackTracking",
				"Problem": "Subset Sum Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/subset-sum-problem2014/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/partition-equal-subset-sum_892980?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "BackTracking",
				"Problem": "The Knight’s tour problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/the-knights-tour-problem-backtracking-1/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/knight-tour_1170518?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "BackTracking",
				"Problem": "Tug of War",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/tug-of-war/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/tug-of-war_985253?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "BackTracking",
				"Problem": "Find shortest safe route in a path with landmines",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/find-shortest-safe-route-in-a-path-with-landmines/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/shortest-safe-route-in-a-field-with-landmines_1164264?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "BackTracking",
				"Problem": "Combinational Sum",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/combination-sum/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/combination-sum_981296?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "BackTracking",
				"Problem": "Find Maximum number possible by doing at-most K swaps",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/largest-number-in-k-swaps/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/find-maximum-number-possible-by-doing-at-most-k-swaps_1169469?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "BackTracking",
				"Problem": "Print all permutations of a string ",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/permutations-of-a-given-string/0",
				"URL2": ""
			},
			{
				"Topic": "BackTracking",
				"Problem": "Find if there is a path of more than k length from a source",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/find-if-there-is-a-path-of-more-than-k-length-from-a-source/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/find-if-there-is-a-path-of-more-than-k-length-from-a-source_1229512?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "BackTracking",
				"Problem": "Longest Possible Route in a Matrix with Hurdles",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/longest-possible-route-in-a-matrix-with-hurdles/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/longest-route_1170525?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "BackTracking",
				"Problem": "Print all possible paths from top left to bottom right of a mXn matrix",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/print-all-possible-paths-from-top-left-to-bottom-right-of-a-mxn-matrix/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/print-all-possible-paths-from-top-left-corner-to-bottom-right-corner-of-a-2-d-matrix_1171152?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "BackTracking",
				"Problem": "Partition of a set intoK subsets with equal sum",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/partition-array-to-k-subsets/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/partition-to-k-equal-sum-subsets_843262?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "BackTracking",
				"Problem": "Find the K-th Permutation Sequence of first N natural numbers",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/find-the-k-th-permutation-sequence-of-first-n-natural-numbers/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/k-th-permutation-sequence-of-first-n-natural-numbers_1164403?topList=love-babbar-dsa-sheet-problems"
			}
		],
	},
	{
		topicName: 'Stacks & Queues',
		position: 9,
		started: false,
		doneQuestions: 0,
		questions: [
			{
				"Topic": "Stacks & Queues",
				"Problem": " Implement Stack from Scratch",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.tutorialspoint.com/javaexamples/data_stack.htm",
				"URL2": "https://www.codingninjas.com/codestudio/problems/stack-implementation-using-array_3210209?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": " Implement Queue from Scratch",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/queue-set-1introduction-and-array-implementation/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/queue-using-array-or-singly-linked-list_2099908?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Implement 2 stack in an array",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/implement-two-stacks-in-an-array/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/two-stacks_983634?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "find the middle element of a stack",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/design-a-stack-with-find-middle-operation/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/delete-middle-element-from-stack_985246?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Implement \"N\" stacks in an Array",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/efficiently-implement-k-stacks-single-array/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/n-stacks-in-an-array_1164271?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Check the expression has valid or Balanced parenthesis or not.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/parenthesis-checker/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/kevin-s-stack-problem_1169465?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Reverse a String using Stack",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/reverse-a-string-using-stack/1",
				"URL2": ""
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Design a Stack that supports getMin() in O(1) time and O(1) extra space.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/special-stack/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/design-a-stack-that-supports-getmin-in-o-1-time-and-o-1-extra-space_842465?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Find the next Greater element",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/next-larger-element/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/next-greater-element_670312?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "The celebrity Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/the-celebrity-problem/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/the-celebrity-problem_982769?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Arithmetic Expression evaluation",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/arithmetic-expression-evalution/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/arithmetic-expression-evaluation_1170517?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Evaluation of Postfix expression",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/evaluation-of-postfix-expression/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/evaluation-of-postfix-expression_841358?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Implement a method to insert an element at its bottom without using any other data structure.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/program-to-insert-an-element-at-the-bottom-of-a-stack/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/insert-an-element-at-its-bottom-in-a-given-stack_1171166?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Reverse a stack using recursion",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/reverse-a-stack-using-recursion/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/reverse-stack-using-recursion_631875?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Sort a Stack using recursion",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/sort-a-stack/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/sort-a-stack_985275?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Merge Overlapping Intervals",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/8a644e94faaa94968d8665ba9e0a80d1ae3e0a2d/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/merge-overlapping-intervals_1082151?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Largest rectangular Area in Histogram",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/maximum-rectangular-area-in-a-histogram/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/largest-rectangle-in-a-histogram_1058184?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Length of the Longest Valid Substring",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/valid-substring0624/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/valid-substring_1172217?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Expression contains redundant bracket or not",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/expression-contains-redundant-bracket-not/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/ninja-and-a-complex-expression_1170758?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Implement Stack using Queue",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/stack-using-two-queues/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/stack-using-queue_795152?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Implement Stack using Deque",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/implement-stack-queue-using-deque/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/stack-using-deque_1170512?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Stack Permutations (Check if an array is stack permutation of other)",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/stack-permutations-check-if-an-array-is-stack-permutation-of-other/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/valid-stack-permutation_1170061?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Implement Queue using Stack  ",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/queue-using-two-stacks/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/queue-using-two-stacks_1170062?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Implement \"n\" queue in an array",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/efficiently-implement-k-queues-single-array/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/n-queue-using-array_1170053?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Implement a Circular queue",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/circular-queue-set-1-introduction-array-implementation/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/circular-queue_1170058?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "LRU Cache Implementationa",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/lru-cache/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/lru-cache-implementation_670276?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Reverse a Queue using recursion",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/queue-reversal/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/reversing-queue_1170046?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Reverse the first “K” elements of a queue",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/reverse-first-k-elements-of-queue/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/reverse-the-first-k-elements-of-a-queue_1164269?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Interleave the first half of the queue with second half",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/interleave-first-half-queue-second-half/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/interleave-the-first-half-of-the-queue-with-the-second-half_1169450?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Find the first circular tour that visits all Petrol Pumps",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/circular-tour/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/find-the-first-circular-tour-that-visits-all-the-petrol-pumps_799923?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Minimum time required to rot all oranges",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/rotten-oranges/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/rotting-oranges_701655?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Distance of nearest cell having 1 in a binary matrix",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/distance-of-nearest-cell-having-1/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/distance-of-nearest-cell-having-1-in-a-binary-matrix_1169913?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "First negative integer in every window of size “k”",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/first-negative-integer-in-every-window-of-size-k/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/first-negative-integer-in-every-window-of-size-k_1164406?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Check if all levels of two trees are anagrams or not.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/check-if-all-levels-of-two-trees-are-anagrams-or-not/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/check-if-all-levels-of-two-trees-are-anagrams-of-each-other-not_1214546?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Sum of minimum and maximum elements of all subarrays of size “k”.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/sum-minimum-maximum-elements-subarrays-size-k/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/sum-of-minimum-and-maximum-elements-of-all-subarrays-of-size-k_1171047?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Minimum sum of squares of character counts in a given string after removing “k” characters.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/game-with-string/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimum-sum-of-squares_1170763?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Queue based approach or first non-repeating character in a stream.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/first-non-repeating-character-in-a-stream/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/first-unique-character-in-a-string_982933?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Stacks & Queues",
				"Problem": "Next Smaller Element",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/next-smaller-element/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/next-smaller-element_1112581?topList=love-babbar-dsa-sheet-problems"
			}
		],
	},
	{
		topicName: 'Heap',
		position: 10,
		started: false,
		doneQuestions: 0,
		questions: [
			{
				"Topic": "Heap",
				"Problem": "Implement a Maxheap/MinHeap using arrays and recursion.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/building-heap-from-array/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/build-min-heap_1171167?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Heap",
				"Problem": "Sort an Array using heap. (HeapSort)",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/heap-sort/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/heap-sort_1262153?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Heap",
				"Problem": "Maximum of all subarrays of size k.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/sliding-window-maximum-maximum-of-all-subarrays-of-size-k/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/maximum-of-all-subarrays-of-size-k_1170789?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Heap",
				"Problem": "“k” largest element in an array",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/k-largest-elements4206/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/k-largest-element_1062624?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Heap",
				"Problem": "Kth smallest and largest element in an unsorted array",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/kth-smallestlargest-element-unsorted-array/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/kth-smallest-element-in-an-unsorted-array_1170531?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Heap",
				"Problem": "Merge “K” sorted arrays. [ IMP ]",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/merge-k-sorted-arrays/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/merge-k-sorted-arrays_975379?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Heap",
				"Problem": "Merge 2 Binary Max Heaps",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/merge-two-binary-max-heap/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/merge-two-binary-max-heaps_1170049?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Heap",
				"Problem": "Kth largest sum continuous subarrays",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/k-th-largest-sum-contiguous-subarray/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/k-th-largest-sum-contiguous-subarray_920398?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Heap",
				"Problem": "Leetcode- reorganize strings",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/reorganize-string/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/rearrange-the-array_975383?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Heap",
				"Problem": "Merge “K” Sorted Linked Lists [V.IMP]",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/merge-k-sorted-linked-lists/1",
				"URL2": ""
			},
			{
				"Topic": "Heap",
				"Problem": "Smallest range in “K” Lists",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/find-smallest-range-containing-elements-from-k-lists/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/smallest-range-from-k-sorted-list_1069356?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Heap",
				"Problem": "Median in a stream of Integers",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/find-median-in-a-stream/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/median-in-a-stream_975268?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Heap",
				"Problem": "Check if a Binary Tree is Heap",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/is-binary-tree-heap/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/is-binary-heap-tree_893136?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Heap",
				"Problem": "Connect “n” ropes with minimum cost",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/minimum-cost-of-ropes/0",
				"URL2": ""
			},
			{
				"Topic": "Heap",
				"Problem": "Convert BST to Min Heap",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/convert-bst-min-heap/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/convert-bst-to-min-heap_920498?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Heap",
				"Problem": "Convert min heap to max heap",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/convert-min-heap-to-max-heap/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/convert-min-heap-to-max-heap_1381084?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Heap",
				"Problem": "Rearrange characters in a string such that no two adjacent are same.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/rearrange-characters4649/1",
				"URL2": ""
			},
			{
				"Topic": "Heap",
				"Problem": "Minimum sum of two numbers formed from digits of an array",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/minimum-sum4058/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimum-sum-of-two-numbers-formed-from-digits-of-an-array_1171162?topList=love-babbar-dsa-sheet-problems"
			}
		],
	},
	{
		topicName: 'Graph',
		position: 11,
		started: false,
		doneQuestions: 0,
		questions: [
			{
				"Topic": "Graph",
				"Problem": "Create a Graph, print it",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://1drv.ms/t/s!AqTOHFO77CqEiRua06v1PATyiFg5",
				"URL2": "https://www.codingninjas.com/codestudio/problems/create-a-graph-and-print-it_1214551?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Graph",
				"Problem": "Create a Graph (for practice)",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/print-adjacency-list-1587115620/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/create-a-graph-and-print-it_1214551?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Graph",
				"Problem": "Implement BFS algorithm ",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/bfs-traversal-of-graph/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/bfs-in-graph_973002?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Graph",
				"Problem": "Implement DFS Algo ",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/depth-first-traversal-for-a-graph/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/dfs-traversal_630462?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Graph",
				"Problem": "Detect Cycle in Directed Graph using BFS/DFS Algo ",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/detect-cycle-in-a-directed-graph/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/detect-cycle-in-a-directed-graph_920545?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Graph",
				"Problem": "Detect Cycle in UnDirected Graph using BFS/DFS Algo ",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/detect-cycle-in-an-undirected-graph/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/cycle-detection-in-undirected-graph_1062670?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Graph",
				"Problem": "Search in a Maze",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/rat-in-a-maze-problem/1",
				"URL2": ""
			},
			{
				"Topic": "Graph",
				"Problem": "Minimum Step by Knight",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/steps-by-knight/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimum-knight-moves_2179628?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Graph",
				"Problem": "flood fill algo",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/flood-fill/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/flood-fill-algorithm_1089687?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Graph",
				"Problem": "Clone a graph",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/clone-graph/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/clone-graph_1103394?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Graph",
				"Problem": "Making wired Connections",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/number-of-operations-to-make-network-connected/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimum-connection-changes_1171168?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Graph",
				"Problem": "word Ladder ",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/word-ladder/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/word-ladder_1102319?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Graph",
				"Problem": "Dijkstra algo",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/implementing-dijkstra-set-1-adjacency-matrix/1/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/dijkstra-s-shortest-path_920469?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Graph",
				"Problem": "Implement Topological Sort ",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/topological-sort/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/topological-sort_982938?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Graph",
				"Problem": "Minimum time taken by each job to be completed given by a Directed Acyclic Graph",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/minimum-time-taken-by-each-job-to-be-completed-given-by-a-directed-acyclic-graph/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/kill-the-snipers-ii_1171163?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Graph",
				"Problem": "Find whether it is possible to finish all tasks or not from given dependencies",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/find-whether-it-is-possible-to-finish-all-tasks-or-not-from-given-dependencies/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/kill-the-snipers_1171161?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Graph",
				"Problem": "Find the no. of Islands",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/find-the-number-of-islands/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/find-number-of-islands_630512?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Graph",
				"Problem": "Given a sorted Dictionary of an Alien Language, find order of characters",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/alien-dictionary/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/ninja-and-alien_1171179?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Graph",
				"Problem": "Implement Kruskal’s Algorithm",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/kruskals-minimum-spanning-tree-algorithm-greedy-algo-2/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimum-spanning-tree_631769?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Graph",
				"Problem": "Implement Prim’s Algorithm",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/prims-minimum-spanning-tree-mst-greedy-algo-5/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/prim-s-mst_1095633?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Graph",
				"Problem": "Total no. of Spanning tree in a graph",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/total-number-spanning-trees-graph/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/total-number-of-spanning-trees-in-a-graph_1171196?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Graph",
				"Problem": "Implement Bellman Ford Algorithm",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/negative-weight-cycle/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/bellmon-ford_2041977?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Graph",
				"Problem": "Implement Floyd Warshall Algorithm",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/implementing-floyd-warshall/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/flloyd-warshall_2041979?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Graph",
				"Problem": "Travelling Salesman Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/travelling-salesman-problem-set-1/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/travelling-salesman-problem_1385180?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Graph",
				"Problem": "Graph Colouring Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/graph-coloring-applications/",
				"URL2": ""
			},
			{
				"Topic": "Graph",
				"Problem": "Snake and Ladders Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/snakes-and-ladders/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/snake-and-ladder_630458?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Graph",
				"Problem": "Find bridge in a graph",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/bridge-in-a-graph/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/bridges-in-graph_893026?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Graph",
				"Problem": "Count Strongly connected Components(Kosaraju Algo)",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/strongly-connected-components-kosarajus-algo/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/count-strongly-connected-components-kosaraju-s-algorithm_1171151?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Graph",
				"Problem": "Check whether a graph is Bipartite or Not",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/bipartite-graph/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/check-graph-is-bipartite-or-not_920551?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Graph",
				"Problem": "Detect Negative cycle in a graph",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/detect-negative-cycle-graph-bellman-ford/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/negative-cycle-in-a-directed-graph_1090517?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Graph",
				"Problem": "Longest path in a Directed Acyclic Graph",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/find-longest-path-directed-acyclic-graph/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/longest-path-in-directed-graph_1172157?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Graph",
				"Problem": "Journey to the Moon",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.hackerrank.com/challenges/journey-to-the-moon/problem",
				"URL2": "https://www.codingninjas.com/codestudio/problems/ninja-and-fruits_1170757?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Graph",
				"Problem": "Cheapest Flights Within K Stops",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/cheapest-flights-within-k-stops/description/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/saving-money_1171195?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Graph",
				"Problem": "Oliver and the Game",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.hackerearth.com/practice/algorithms/graphs/topological-sort/practice-problems/algorithm/oliver-and-the-game-3/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/hide-and-seek_1172173?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Graph",
				"Problem": "Water Jug problem using BFS",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/water-jug-problem-using-bfs/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/ninja-and-vessels_1172168?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Graph",
				"Problem": "Find if there is a path of more thank length from a source",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/find-if-there-is-a-path-of-more-than-k-length-from-a-source/",
				"URL2": ""
			},
			{
				"Topic": "Graph",
				"Problem": "M-Colouring Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/m-coloring-problem/0",
				"URL2": ""
			},
			{
				"Topic": "Graph",
				"Problem": "Minimum edges to reverse to make path from source to destination",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/minimum-edges-reverse-make-path-source-destination/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/reverse-edges_1200162?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Graph",
				"Problem": "Paths to travel each nodes using each edge(Seven Bridges)",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/paths-travel-nodes-using-edgeseven-bridges-konigsberg/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/euler-path_1214547?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Graph",
				"Problem": "Vertex Cover Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/vertex-cover-problem-set-1-introduction-approximate-algorithm-2/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/vertex-cover-problem_1081481?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Graph",
				"Problem": "Chinese Postman or Route Inspection",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/chinese-postman-route-inspection-set-1-introduction/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimum-travel-time_1171046?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Graph",
				"Problem": "Number of Triangles in a Directed and Undirected Graph",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/number-of-triangles-in-directed-and-undirected-graphs/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/number-of-triangles-in-directed-and-undirected-graphs_1214931?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Graph",
				"Problem": "Minimise the cashflow among a given set of friends who have borrowed money from each other",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/minimize-cash-flow-among-given-set-friends-borrowed-money/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimum-cash-flow_975372?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Graph",
				"Problem": "Two Clique Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/two-clique-problem-check-graph-can-divided-two-cliques/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/two-cliques_1214524?topList=love-babbar-dsa-sheet-problems"
			}
		],
	},
	{
		topicName: 'Trie',
		position: 12,
		started: false,
		doneQuestions: 0,
		questions: [
			{
				"Topic": "Trie",
				"Problem": "Construct a trie from scratch",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/trie-insert-and-search/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/implement-trie_631356?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Trie",
				"Problem": "Find shortest unique prefix for every word in a given list",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/find-all-shortest-unique-prefixes-to-represent-each-word-in-a-given-list/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/shortest-unique-prefix_1094887?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Trie",
				"Problem": "Word Break Problem | (Trie solution)",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/word-break-problem-trie-solution/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/word-break_1094901?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Trie",
				"Problem": "Given a sequence of words, print all anagrams together",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/k-anagrams-1/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/group-anagrams_800285?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Trie",
				"Problem": "Implement a Phone Directory",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/phone-directory/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/implement-a-phone-directory_1062666?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Trie",
				"Problem": "Print unique rows in a given boolean matrix",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/unique-rows-in-boolean-matrix/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/unique-matrix_1214696?topList=love-babbar-dsa-sheet-problems"
			}
		],
	},
	{
		topicName: 'Dynamic Programming',
		position: 13,
		started: false,
		doneQuestions: 0,
		questions: [
			{
				"Topic": "Dynamic Programming",
				"Problem": "Coin ChangeProblem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/coin-change2448/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/ways-to-make-coin-change_630471?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Knapsack Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/0-1-knapsack-problem/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/0-1-knapsack_920542?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Binomial CoefficientProblem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/ncr1019/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/binomial-coefficient-problem_1229410?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Permutation CoefficientProblem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/permutation-coefficient/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/permutationcoefficient_1214975?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Program for nth Catalan Number",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/geek-and-his-binary-strings1951/1/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/catalan-number_893076?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Matrix Chain Multiplication ",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/matrix-chain-multiplication0303/1/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/matrix-chain-multiplication_975344?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Edit Distance",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/edit-distance3702/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/edit-distance_630420?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Subset Sum Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/subset-sum-problem2014/1",
				"URL2": ""
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Friends Pairing Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/friends-pairing-problem5425/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/friends-pairing-problem_1214625?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Gold Mine Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/gold-mine-problem2608/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/gold-mine-problem_799363?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Assembly Line SchedulingProblem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/assembly-line-scheduling-dp-34/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimum-time-to-cross-all-checkpoints_1214626?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Painting the Fenceproblem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/painting-the-fence3727/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/ninja-and-the-fence_3210208?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Maximize The Cut Segments",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/cutted-segments/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/cut-into-segments_1214651?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Longest Common Subsequence",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/longest-common-subsequence/0",
				"URL2": ""
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Longest Repeated Subsequence",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/longest-repeating-subsequence/0",
				"URL2": ""
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Longest Increasing Subsequence",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/longest-increasing-subsequence/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/longest-increasing-subsequence_630459?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Space Optimized Solution of LCS",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/space-optimized-solution-lcs/",
				"URL2": ""
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "LCS (Longest Common Subsequence) of three strings",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/lcs-of-three-strings/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/lcs-of-3-strings_893011?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Maximum Sum Increasing Subsequence",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/maximum-sum-increasing-subsequence4749/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/ninja-at-the-gym_1112624?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Count all subsequences having product less than K",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/count-subsequences-product-less-k/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/count-the-number-of-subsequences-having-product-not-more-than-p_1214647?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Longest subsequence such that difference between adjacent is one",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/longest-subsequence-such-that-difference-between-adjacents-is-one4724/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/longest-subsequence-with-difference-one_1214549?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Maximum subsequence sum such that no three are consecutive",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/max-sum-without-adjacents-2/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/maximum-subsequence-sum-such-that-no-three-are-consecutive_1215007?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Egg Dropping Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/egg-dropping-puzzle/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/cut-logs_982770?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Maximum Length Chain of Pairs",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/max-length-chain/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/maximum-length-pair-chain_985258?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Maximum size square sub-matrix with all 1s",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/largest-square-formed-in-a-matrix/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/maximum-area-square_981268?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Maximum sum of pairs with specific difference",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/pairs-with-specific-difference/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/maximum-sum-of-pairs-with-specific-difference_1230548?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Min Cost PathProblem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/path-in-matrix3805/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/min-cost-path_842565?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Maximum difference of zeros and ones in binary string",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/maximum-difference-of-zeros-and-ones-in-binary-string4111/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/maximum-difference-of-zeros-and-ones-in-a-binary-string_1203919?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Minimum number of jumps to reach end",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/minimum-number-of-jumps/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/jump-game_893178?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Minimum cost to fill given weight in a bag",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/minimum-cost-to-fill-given-weight-in-a-bag1956/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimum-cost-to-buy-rice_3210212?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Minimum removals from array to make max –min <= K",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/minimum-removals-array-make-max-min-k/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimum-removals_1214550?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Longest Common Substring",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/longest-common-substring/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/longest-common-substring_1235207?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Count number of ways to reacha given score in a game",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/reach-a-given-score/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/ninja-and-his-exam_1214657?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Count Balanced Binary Trees of Height h",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/bbt-counter/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/number-of-balanced-binary-trees_1062690?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "LargestSum Contiguous Subarray [V>V>V>V IMP ]",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/kadanes-algorithm/0",
				"URL2": ""
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Smallest sum contiguous subarray",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/smallest-sum-contiguous-subarray/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimum-sum-subarray_1062622?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Unbounded Knapsack (Repetition of items allowed)",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/knapsack-with-duplicate-items4201/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/unbounded-knapsack_1215029?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Word Break Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/word-break/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/ninja-the-exam-instructor_1215010?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Largest Independent Set Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/largest-independent-set-problem-dp-26/",
				"URL2": ""
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Partition problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/subset-sum-problem2014/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/partition_1172151?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Longest Palindromic Subsequence",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/longest-palindromic-subsequence-1612327878/1/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/longest-palindromic-subsequence_842787?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Count All Palindromic Subsequence in a given String",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/count-palindromic-subsequences/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/count-palindromic-subsequences_1062696?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Longest Palindromic Substring",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/longest-palindromic-substring/",
				"URL2": ""
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Longest alternating subsequence",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/longest-alternating-subsequence/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/longest-alternating-subsequence_1214645?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Weighted Job Scheduling",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/weighted-job-scheduling/",
				"URL2": ""
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Coin game winner where every player has three choices",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/coin-game-winner-every-player-three-choices/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/coin-game-winner-where-every-player-has-three-choices_1229492?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Count Derangements (Permutation such that no element appears in its original position) [ IMPORTANT ]",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/count-derangements-permutation-such-that-no-element-appears-in-its-original-position/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/count-derangements_1199092?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Maximum profit by buying and selling a share at most twice [ IMP ]",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/maximum-profit-by-buying-and-selling-a-share-at-most-twice/",
				"URL2": ""
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Optimal Strategy for a Game",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/optimal-strategy-for-a-game/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/optimal-strategy-for-a-game_975479?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Optimal Binary Search Tree",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/optimal-binary-search-tree-dp-24/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimum-cost-bst_3210619?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Palindrome PartitioningProblem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/palindromic-patitioning4845/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/palindromic-partitioning_1063252?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Word Wrap Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/word-wrap/0",
				"URL2": ""
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Mobile Numeric Keypad Problem [ IMP ]",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/mobile-numeric-keypad5456/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/mike-and-mobile_1082139?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Boolean Parenthesization Problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/boolean-parenthesization/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/problem-name-boolean-evaluation_1214650?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Largest rectangular sub-matrix whose sum is 0",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/largest-rectangular-sub-matrix-whose-sum-0/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/sub-matrix-with-sum-zero_1063254?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Largest area rectangular sub-matrix with equal number of 1’s and 0’s [ IMP ]",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/largest-area-rectangular-sub-matrix-equal-number-1s-0s/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/largest-sub-matrix-with-equal-0-s-and-1-s_3210616?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Maximum sum rectangle in a 2D matrix",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/maximum-sum-rectangle/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/maximum-sum-rectangle_875115?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Maximum profit by buying and selling a share at most k times",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/maximum-profit4657/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/best-time-to-buy-and-sell-stock_1080698?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Find if a string is interleaved of two other strings",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/interleaved-strings/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/interleaving-two-strings_1062567?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Dynamic Programming",
				"Problem": "Maximum Length of Pair Chain",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/maximum-length-of-pair-chain/",
				"URL2": ""
			}
		],
	},
	{
		topicName: 'Bit Manipulation',
		position: 14,
		started: false,
		doneQuestions: 0,
		questions: [
			{
				"Topic": "Bit Manipulation",
				"Problem": "Count set bits in an integer",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/set-bits0143/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/set-bits_1164179?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Bit Manipulation",
				"Problem": "Find the two non-repeating elements in an array of repeating elements",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/finding-the-numbers0215/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/unique-pair-using-bits_972997?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Bit Manipulation",
				"Problem": "Count number of bits to be flipped to convert A to B",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/bit-difference/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/number-of-flips_3125902?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Bit Manipulation",
				"Problem": "Count total set bits in all numbers from 1 to n",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/count-total-set-bits/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/count-set-bits_1112627?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Bit Manipulation",
				"Problem": "Program to find whether a no is power of two",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/power-of-2/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/power-of-two_893061?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Bit Manipulation",
				"Problem": "Find position of the only set bit",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/find-position-of-set-bit3706/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/find-the-lone-set-bit_1062725?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Bit Manipulation",
				"Problem": "Copy set bits in a range",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/copy-set-bits-in-a-range/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/copy-bits-in-range_3150011?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Bit Manipulation",
				"Problem": "Divide two integers without using multiplication, division and mod operator",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/divide-two-integers-without-using-multiplication-division-mod-operator/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/divide-two-integers_1112617?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Bit Manipulation",
				"Problem": "Calculate square of a number without using *, / and pow()",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/calculate-square-of-a-number-without-using-and-pow/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/calculate-square-of-a-number_1112623?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Topic": "Bit Manipulation",
				"Problem": "Power Set",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/power-set4302/1",
				"URL2": ""
			}
		],
	},
];
export const version = 100000029;
